module.exports = __webpack_public_path__ + "img/c-thermometer-img8-2.4a6d6d92.png";